import React from "react";
import CruiseSearchWidget from "./CruiseSearchWidget";

const Header =()=>{
    return(
        <>
        <div className="Header-Container">
          
      
          <div className="main-heading">
            {/* <h1>Asia's One Stop Shop <br></br> For Cruising</h1> */}
          </div>

          <div className="SearchCruise">
            <h2>Search For Cruise</h2>
          
               <CruiseSearchWidget/>
        
          </div>


        </div>
        
        </>
    );
}

export default Header ;